import styled, { keyframes } from 'styled-components';
import { Avatar } from "@material-ui/core";

export const StyledAvatar = styled(Avatar)<{textColor?: string, backgroundColor?: string}>`
  && {
    width: 35px;
    height: 35px;
    margin-right: 10px;
    color: ${props => props.textColor};
    background-color: ${props => props.backgroundColor};
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 3%;
  padding-right: 8px;
  margin-bottom: 2px;
  align-items: flex-end;
`;

export const TailOut = styled.span`
  color: #dcf8c6;
  display: block;
  height: 13px;
  width: 8px;
  z-index: 1000;
  margin-left: -8px;
  margin-top: -2px;
  order: 2;
`;

export const TailIn = styled.span`
  left: -8px;
  display: block;
  height: 13px;
  position: absolute;
  top: -2px;
  width: 8px;
  z-index: 100;
  color: #fff;
`;

export const TextContainer = styled.div<{isOut: boolean}>`
  position: relative;
  z-index: 200;
  width: ${props => props.isOut ? 'calc(100% - 45px)' : '100%'};
  border-radius: 7.5px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  background-color: #dcf8c6;
  order: 1;
`;

export const MessageStatusError = styled.div`
  height: 100%;
  display: flex;
  align-self: center;
  z-index: 1000;
  pointer-events: none;
`;

export const MessageErrorIcon = styled.div`
  background-color: rgb(223, 51, 51);
  border-radius: 50%;
  border: 1px solid #fff;
  align-items: center;
  color: #fff;
  height: 24px;
  justify-content: center;
  pointer-events: auto;
  width: 24px;
  margin-left: 5px;
  &[role="button"] {
    cursor: pointer;
  }
`;

export const ContainerLoadingMedia = styled.div`
  left: 0;
  align-items: center;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, .16);
`;

export const RowLoadingMedia = styled.div`
  position: relative;
  display: inline-block;
  height: 50px;
  width: 50px;
`;

export const LoadingIconDiv = styled.div`
  left: 0;
  position: absolute;
  top: 0;
  width: 50px;
  height: 50px;
`;

export const ContainerLoadingMediaBefore = styled.div`
  background-color: rgba(0, 0, 0, .07);
  border-radius: 50%;
  height: 44px;
  width: 44px;
  position: relative;
`;


export const ContainerLittleLoadingMedia = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  height: 34px;
  justify-content: center;
  width: 34px;
  /* background-color: rgba(0, 0, 0, .16); */
`;

export const RowLittleLoadingMedia = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
`;


export const LittleLoadingIconDiv = styled.div`
  left: 0;
  position: absolute;
`;


export const ContainerLittleLoadingMediaBefore = styled.div`
  background-color: rgba(0, 0, 0, .07);
  border-radius: 50%;
  width: 100%;
  height: 100%;
`;

export const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
  }
`;

export const dotTyping = keyframes`
  0% {
    box-shadow: 9984px 0 0 0 grey, 9999px 0 0 0 grey, 10014px 0 0 0 grey;
  }
  16.667% {
    box-shadow: 9984px -10px 0 0 grey, 9999px 0 0 0 grey, 10014px 0 0 0 grey;
  }
  33.333% {
    box-shadow: 9984px 0 0 0 grey, 9999px 0 0 0 grey, 10014px 0 0 0 grey;
  }
  50% {
    box-shadow: 9984px 0 0 0 grey, 9999px -10px 0 0 grey, 10014px 0 0 0 grey;
  }
  66.667% {
    box-shadow: 9984px 0 0 0 grey, 9999px 0 0 0 grey, 10014px 0 0 0 grey;
  }
  83.333% {
    box-shadow: 9984px 0 0 0 grey, 9999px 0 0 0 grey, 10014px -10px 0 0 grey;
  }
  100% {
    box-shadow: 9984px 0 0 0 grey, 9999px 0 0 0 grey, 10014px 0 0 0 grey;
  }
`;

export const DotTyping = styled.div`
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: grey;
  color: grey;
  box-shadow: 9984px 0 0 0 grey, 9999px 0 0 0 grey, 10014px 0 0 0 grey;
  animation: ${dotTyping} 0.9s infinite linear;
`;

export const DotContainer = styled.div`
  position: relative;
  z-index: 200;
  width: 90px;
  border-radius: 7.5px;
  box-shadow: 0 1px 0.5px rgb(0 0 0 / 13%);
  background-color: white;
  -webkit-order: 1;
  -ms-flex-order: 1;
  order: 1;
  display: flex;
  height: 39px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
`;

export const MessageBody = styled.div`
  border-radius: 7.5px;
  color: #303030;
  display:flex;
  align-items: center;
  font-size: 13px;
  line-height: 13px;
  position: relative;
  word-break: break-word;
  animation: ${fadeIn} 0.4s ease-in-out;
`;
